import styled from "styled-components";
import media from "constants/media";

import NextImage from "next/image";
import Description from "components/shared/hero/description/Description";

export const HeroStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 100%;
    margin: 30px auto 0;

    ${media.mdUp`
        flex-direction: row;
        justify-content: left;

        max-width: 780px;
        margin: 70px auto 0;

    `}
`;

export const Paragraph = styled(Description)`
    margin: 0;

    ${media.mdUp`
        text-align: left;
    `}
`;

export const Text = styled.div`
    position: relative;
    z-index: 2;

    margin: 0 0 30px;

    ${media.mdUp`
        max-width: 480px;
        margin: -20px 0 0;
    `}
`;

export const Image = styled.div`
    position: relative;
    z-index: 1;

    width: 280px;
    height: 245px;

    padding: 10px 20px;

    text-align: left;

    background-color: transparent;
    background-image: url("/images/doubler-x2.svg");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;

    ${media.mdUp`
        width: 580px;
        height: 315px;
        
        margin: 0 -195px 0 -95px;
        padding: 0;
        
        background-size: 343px auto;
        background-position: right center;
        flex: 1 0 auto;
    `}

    ${({ imageType }) => (imageType === "desktop" ? media.desktopOnly : "")};
    ${({ imageType }) => (imageType === "mobile" ? media.mobileOnly : "")};
`;

export const DoublerImage = styled(NextImage)`
    width: 100%;
    max-width: 240px;

    ${media.mdUp`
        max-width: 390px;
    `}
`;
